module.exports = "<span data-ng-message=required> Required </span> ";